
import { base_url } from 'Backend/api';
import Footer from 'components/Footer';
import ResponsiveTopNavigation from 'components/navigation/ResponsiveTopNavigation';
import ResponsiveTopNavigation2 from 'components/navigation/ResponsiveTopNavigation2';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import orderAnimation from "../../../public/assets/lottie/OrderSent.json";
import Lottie from "lottie-react";
import AppSpinner from 'components/ui/AppSpinner';

const CompleteOrderPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [checkoutData, setCheckoutData] = useState(null);
  const [placingOrder, setPlacingOrder] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [driverNotes, setDriverNotes] = useState('');
  const [selectedAddress, setSelectedAddress] = useState(null);

  // جلب بيانات الخروج
  const fetchCheckout = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${base_url}/api/checkout`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (res.ok && data.status) {
        setCheckoutData(data.data);

        if (data.data.active_address) {
          setSelectedAddress(data.data.active_address.id);

          // أول ما الصفحة تحمل، لو مفيش رقم
          if (!data.data.active_address.receiver_phone) {
            toast.error('لا يوجد هاتف مسجل');
          }
        }

        if (data.data.options?.payment_types?.length > 0) {
          setSelectedPayment(data.data.options.payment_types[0].key);
        }
      }
    } catch (error) {
      console.error('Checkout error:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCheckout();
  }, []);

  // رقم الهاتف من العنوان النشط
  const phoneNumber = checkoutData?.active_address?.receiver_phone;

  // تنفيذ الطلب
  const placeOrder = async () => {
    if (!phoneNumber) {
      toast.error('لا يمكن إتمام الطلب بدون رقم موبايل');
      return;
    }

    if (!selectedAddress) {
      toast.error('لا يمكن إتمام الطلب بدون عنوان توصيل');
      return;
    }

    try {
      setPlacingOrder(true);
      const token = localStorage.getItem('token');

      const res = await fetch(`${base_url}/api/checkout/place-order`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          delivery_address_id: selectedAddress,
          payment_type: 'cash_on_delivery',
          notes: driverNotes || 'توصيل سريع',
        }),
      });

      const data = await res.json();

      if (res.ok && data.status) {
        // toast.success(data.message);
        navigate('/orders');
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Place order error:', error);
      alert('حدث خطأ أثناء تنفيذ الطلب');
    } finally {
      setPlacingOrder(false);
    }
  };

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
        <AppSpinner />
      </div>
    );
  }

  return (
    <>
      <div className="min-h-screen bg-gray-50 font-[cairo] text-sm md:text-base" dir="rtl">
        <ResponsiveTopNavigation2 />

        <div className="max-w-4xl mx-auto pb-28 mt-20 px-3 md:px-4">
          <div className="bg-white">
            {/* Phone */}
            <div className="flex justify-between flex-row mt-3 px-3 md:px-4 py-2 mb-2">
              <h2 className="text-base md:text-lg font-bold text-gray-900 text-right items-center font-[cairo]">
                عنوان التوصيل
              </h2>

              <div className="bg-amber-50 rounded-[4px] px-3 py-2 md:px-4 flex items-center justify-between">
                <div className="flex items-center gap-2 flex-wrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 text-orange-500"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z"
                      clipRule="evenodd"
                    />
                  </svg>

                  <span className="text-gray-700 font-medium break-all">
                    {phoneNumber || 'لا يوجد هاتف مسجل'}
                  </span>
                </div>
              </div>
            </div>

            {/* Address */}
            {checkoutData?.active_address ? (
              <div className="rounded-lg mb-3 pb-2 flex ">
                <div className="flex-1 px-3 md:px-4 py-2">
                  <p className="text-sm md:text-base break-words">
                    {checkoutData.active_address.description}
                  </p>
                </div>
              </div>
            ) : (
              <p className="text-red-500 text-sm">لا يوجد عنوان نشط</p>
            )}
          </div>

          {/* Delivery Time */}
          {checkoutData?.estimated_delivery?.total_eta_message && (
            <div className="bg-white mt-3 px-3 md:px-4 py-4 flex items-center gap-2 flex-wrap">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 text-primary flex-shrink-0"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-primary font-medium text-sm md:text-base">
                {checkoutData.estimated_delivery.total_eta_message}
              </span>
            </div>
          )}

          {/* Payment */}
          <div className="bg-white mt-3 px-3 md:px-4 py-4">
            <h2 className="text-base md:text-lg font-bold mb-4 font-[cairo]">طرق الدفع</h2>
            <div className="flex items-center py-2 cursor-not-allowed">
              <div className="w-5 h-5 rounded-full border-2 flex items-center justify-center border-orange-500 bg-orange-500">
                <div className="w-2 h-2 bg-white rounded-full" />
              </div>
              <span className="mr-2 text-sm md:text-base">الدفع عند الاستلام</span>
            </div>
          </div>

          {/* Notes */}
          <div className="bg-white mt-3 px-3 md:px-4 py-4">
            <h2 className="font-[cairo] text-base md:text-lg font-bold text-gray-900 mb-4 text-right">
              أضف ملاحظات للسائق
            </h2>
            <textarea
              value={driverNotes}
              onChange={(e) => setDriverNotes(e.target.value)}
              placeholder="اكتب ملاحظاتك"
              rows={5}
              className="w-full bg-white rounded-[4px] px-4 py-3 text-right text-black placeholder-gray-400 resize-none text-sm md:text-base outline-none focus:ring-1 focus:ring-red-500 focus:border-red-500"
              dir="rtl"
            />
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t shadow-lg z-20">
          <div className="max-w-3xl mx-auto px-3 md:px-4 py-4 flex items-center justify-between gap-3">
            <button
              onClick={placeOrder}
              className="flex-1 bg-primary text-white py-3 rounded-[4px] text-sm md:text-lg"
              disabled={placingOrder}
            >
              {placingOrder ? 'جاري تأكيد الطلب...' : 'تأكيد وإنهاء'}
            </button>

            <div className="text-right">
              <p className="text-xs text-gray-500">المجموع الإجمالي</p>
              <p className="text-lg md:text-xl font-bold">{checkoutData?.summary?.total} ل.س</p>
            </div>
          </div>
        </div>

        {placingOrder && (
  <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
    
      
      <Lottie
        animationData={orderAnimation}
        loop={false} 
        className="w-24 h-24 mx-auto"
      />

      
    </div>
  
)}

        {/* <Footer /> */}
      </div>
    </>
  );
};

export default CompleteOrderPage;
